import ApiServices, {REFRESH_TOKEN} from "../config/ApiServices";
import api from "../utils/api";
import store from "../store";
import {resetMerchant} from "../store/merchant";
import {HIDE_CHANGE_MERCHANT_POPUP} from "../config/event";
import {setToken} from "../store/token";

export class RefreshTokenEvent {
    params = {};

    constructor (params = null) {
        this.params = params;
    }

    static getEventName () {
        return 'RefreshTokenEvent';
    }
}

export class RefreshTokenEventListener {
    dispatcher;

    constructor (dispatcher = null) {
        this.dispatcher = dispatcher;
    }

    async handle (event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[REFRESH_TOKEN]['apiName'], event.params);
        if (res['status']) {
            store.dispatch(setToken({
                value: res['data']['token'],
                ttl: res['data']['ttl'],
                refreshTtl: res['data']['refresh_ttl'],
            }))
            return event['success'](res['data']['token']);
        }
        return event['failed']();
    }

    async after () {
        this.dispatcher.dispatch(HIDE_CHANGE_MERCHANT_POPUP);
        window.location.reload();
    }
}